/**
 * 行灯（あんどん）。この画面で唯一動く要素。
 * おじさんが考えている間だけ灯りがゆっくり息をし、話し始めると静かになる。
 */
export function Lamp({ thinking = false }: { thinking?: boolean }) {
  return (
    <span className={`lamp${thinking ? ' lamp--thinking' : ''}`} aria-hidden="true">
      <span className="lamp__glow" />
      <span className="lamp__shade">
        <svg viewBox="0 0 32 32" fill="none">
          <path
            d="M10.5 8.5h11l1.6 12.4a1.2 1.2 0 0 1-1.2 1.35H10.1a1.2 1.2 0 0 1-1.2-1.35L10.5 8.5Z"
            fill="var(--accent)"
            fillOpacity="0.9"
          />
          <path d="M12.5 8.5h7" stroke="var(--ink)" strokeOpacity="0.35" strokeWidth="1.2" />
          <path d="M13 25.5h6" stroke="var(--ink)" strokeWidth="1.6" strokeLinecap="round" />
        </svg>
      </span>
    </span>
  );
}
